document.addEventListener('DOMContentLoaded', function() {
    var modalCloseButtons = document.querySelectorAll('.close');

    modalCloseButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Show slideshow buttons when modal closes
            var slideshowButtons = document.querySelectorAll('.slider-buttons');
            slideshowButtons.forEach(function(element) {
                element.style.display = 'block';
            });
        });
    });
});
